import { PiCertificateDuotone } from "react-icons/pi";
import { FaLaptopCode } from "react-icons/fa";

const LucasLmirSection = () => {
  return (
    <section className="bg-white py-24 px-6 sm:px-12 text-gray-900 rounded-2xl">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Imagem */}
        <div className="flex justify-center">
          <img
            src="/img/lucas.png"
            alt="Lucas Lourenço Miranda"
            className="w-64 h-64 object-cover rounded-full shadow-lg border-4 border-yellow-400"
          />
        </div>

        {/* Texto */}
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-yellow-600 mb-2">
            Quem está por trás do Vintree
          </h3>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
            Um criador que viveu os dois lados: a loja física e o marketing
            digital
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-700">
            Sou Lucas Lourenço Miranda. Atuo há mais de 10 anos no varejo
            físico, com foco em moda e atendimento ao cliente. Com o tempo,
            percebi que a maioria das soluções digitais eram feitas para
            produtos digitais — e não para quem vende presencialmente.
          </p>
          <p className="mt-4 text-lg leading-8 text-gray-700">
            Foi aí que surgiu o Vintree: uma vitrine virtual pensada para ajudar
            lojistas como eu a atender melhor, vender mais e manter o cliente na
            experiência da loja física.
          </p>

          {/* Certificações */}
          <div className="mt-6 space-y-1">
            <p className="text-sm text-gray-500">
              <PiCertificateDuotone className="inline-block align-middle mr-2" />{" "}
              IPOG – MBA em Marketing e Inteligência Digital
            </p>
            <p className="text-sm text-gray-500">
              <PiCertificateDuotone className="inline-block align-middle mr-2" />{" "}
              Empretec – Programa de comportamento empreendedor (SEBRAE)
            </p>
            <p className="text-sm text-gray-500">
              <PiCertificateDuotone className="inline-block align-middle mr-2" />{" "}
              <a
                className="text-blue-600 hover:underline"
                href="https://www.udacity.com/certificate/e/9b8f46aa-b603-11e7-93da-a3546c9ba871"
                target="_blank"
                rel="noreferrer"
              >
                Udacity – Nanodegree Marketing Digital
              </a>
            </p>
            <p className="text-sm text-gray-500">
              <PiCertificateDuotone className="inline-block align-middle mr-2" />{" "}
              <a
                className="text-blue-600 hover:underline"
                href="https://www.coursera.org/account/accomplishments/verify/BGFHYD2NTEDN"
                target="_blank"
                rel="noreferrer"
              >
                Coursera – Management of Fashion and Luxury Companies
              </a>
            </p>
            <p className="text-sm text-gray-500">
              <FaLaptopCode className="inline-block align-middle mr-2" />{" "}
              Programador com foco em sistemas para varejo, usando React e
              Node.js.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LucasLmirSection;
